import { useContext, useEffect, useState } from 'react'

import { Box, Tabs } from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { CompanyProduction } from '../../../../components/CompanyProduction/company-production.comp'
import { ProductionCapacity } from '../../../../components/ProductionCapacity/production-capacity.comp'
import { ProviderRisks } from '../../../../components/ProviderRisks/provider-risks.comp'
import { CompanySegment } from '../../../../sdk/common/company.enum'
import { ProviderContext } from '../../provider.context'
import { ProviderCertificates } from '../ProviderCertificates/provider-certificates.comp'
import { ProviderDeclarations } from '../ProviderDeclarations/provider-declarations.comp'
import { ProviderDocuments } from '../ProviderDocuments/provider-documents.comp'
import { ProviderList } from '../ProviderList/provider-list.comp'

export const ProviderTabs = () => {
  const theme = useTheme()

  const { data, activeTab, socialEnvironmentalRisk, actions } =
    useContext(ProviderContext)

  const [tabs, setTabs] = useState([
    'Fornecedores e clientes',
    'Riscos socioambientais',
    'Certificados',
    'Declarações',
    'Documentos',
  ])

  useEffect(() => {
    if (data?.segment === CompanySegment.SUBCONTRACTOR) {
      setTabs([
        'Documentos',
        'Capacidade Produtiva',
        'Produção mensal',
        'Riscos socioambientais',
        'Declarações',
        'Certificados',
      ])
    }
  }, [])

  return (
    <Box
      borderRadius={theme.border_radius.table}
      boxShadow={theme.box_shadow.card}
      backgroundColor={theme.colors.custom.white}
      padding={3}
      gap={4}
      direction="column"
      width="100%"
      id="tabs"
    >
      <Tabs
        active={activeTab}
        onChangeTab={(_activeTab) => actions.setActiveTab(_activeTab)}
        tabs={tabs}
      />
      {activeTab === 'Fornecedores e clientes' && <ProviderList />}
      {activeTab === 'Documentos' && <ProviderDocuments />}
      {activeTab === 'Capacidade Produtiva' && (
        <ProductionCapacity companyId={data?.id ?? ''} />
      )}
      {activeTab === 'Produção mensal' && (
        <CompanyProduction companyId={data?.id ?? ''} />
      )}
      {activeTab === 'Riscos socioambientais' && (
        <ProviderRisks
          socialEnvironmentalRisk={socialEnvironmentalRisk ?? undefined}
        />
      )}
      {activeTab === 'Declarações' && (
        <ProviderDeclarations companyTaxId={data?.taxId ?? ''} />
      )}
      {activeTab === 'Certificados' && <ProviderCertificates />}
    </Box>
  )
}
